export default "__VITE_ASSET__BMU6NvTo__"